import React, { useState } from 'react'
import InfoCard from '../../../components/info-card'
import Tabs from '../../../components/tabs'

const tabs = ['Buying', 'Selling']

export default function AllInOneServicesSection() {
  const [activeTabIndex, setActiveTabIndex] = useState(0)

  return (
    <div className='root'>
      <h2>All-in-one services</h2>
      <div className='tabsWrapper'>
        <Tabs
          activeIndex={activeTabIndex}
          onChange={(newIndex) => setActiveTabIndex(newIndex)}
          tabs={tabs}
        />
      </div>

      <div className='tabContent'>
        {activeTabIndex === 0 && (
          <InfoCard isSlide handleClick={() => setActiveTabIndex(activeTabIndex + 1)}>
            <div className='imageContainer flex justifyCenter'>
              <img
                src='/images/listing-vehicles.png'
                alt='listing vehicles'
                width='880'
                height='510'
              />
            </div>
            <aside>
              <h3>Buying a vehicle</h3>
              <p>
                Buying a vehicle through privauto is both safe and easy. We offer a 7 day money
                back guarantee, we ensure you get a clean title, access to financing and can bring
                it right to your door. Our concierge team will assist you every step of the way! No
                other classified site does all of this!
              </p>
            </aside>
          </InfoCard>
        )}
        {activeTabIndex === 1 && (
          <InfoCard isSlide handleClick={() => setActiveTabIndex(0)}>
            <div className='imageContainer flex justifyCenter'>
              <img
                src='/images/auction-process.png'
                alt='auction process'
                width='880'
                height='510'
              />
            </div>
            <aside>
              <h3>Selling your vehicle</h3>
              <p>
                Simply follow the privauto process for creating a listing for your vehicle. We
                will guide you through the process of taking photos and asking the key details about
                your vehicle to ensure you get the true value for it.
              </p>
            </aside>
          </InfoCard>
        )}
      </div>

      <style jsx>{`
        .root {
          padding-top: 11.2rem;
          padding-bottom: 7rem;
          // background: transparent linear-gradient(rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0)) 0 0
          //   no-repeat padding-box;

          background-color: #212529;
        }
        .tabsWrapper {
          max-width: 108rem;
          width: 100%;
          margin: 2rem auto 2.5rem;
        }

        .tabContent {
          max-width: 153.2rem;
          margin: 2.5rem auto 0;
        }

        .imageContainer {
          max-width: 101.7rem;
          width: 100%;
          min-height: 62.3rem;
          background: linear-gradient(180deg, #fff, rgba(255, 255, 255, 0));

          img {
            width: 100%;
            height: 100%;
          }

          img {
            &:not(.withNoPadding) {
              padding: 5rem 7rem;
              object-fit: contain;
            }
          }

          img {
            &.withNoPadding {
              object-fit: cover;
            }
          }
        }

        aside {
          max-width: 51.3rem;
          padding: 7rem 7.5rem 7rem 7.3rem;
        }

        h3 {
          margin: 0 0 1.4rem;
          line-height: 4.3rem;
          font-size: 3.2rem;
        }

        p {
          line-height: 3rem;
          font-size: 2.2rem;
        }

        h2 {
          text-align: center;
          line-height: 7.1rem;
          font-size: 5.4rem;
          color: #fff;
        }

        @media (max-width: 1024px) {
          .root {
            padding-top: 3rem;
          }
          .tabsWrapper {
            margin: 1.3rem 0 1.9rem;
            padding: 0 1.2rem;
          }

          .tabContent {
            margin: 1.9rem 0 0;
          }

          .imageContainer {
            min-height: unset;

            img {
              &:not(.withNoPadding) {
                padding: 1.6rem 4.3rem;
              }
            }
          }

          h2 {
            line-height: 2.6rem;
            font-size: 2rem;
          }

          aside {
            max-width: 100%;
            padding: 2.6rem 2.8rem 6.7rem;
          }

          h3 {
            margin: 0 0 1.1rem;
            line-height: 2rem;
            font-size: 1.4rem;
          }

          p {
            line-height: unset;
            font-size: 1.4rem;
          }
        }
      `}</style>
    </div>
  )
}
